import { Component, Input, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ApiError, MessageService, FormsUtilsService, notCloseMessageOptions } from '../../../../../core';
import { CampanhaFilter } from '../../filter';
import { CampanhaPedidoNaoLiberadoViewComponent } from '../nao-liberado-view';
import { PedidoLiberarRequest } from '../../../../pedido/nao-liberado/adapters';
import { PedidoNaoLiberadoHttpService } from '../../../../pedido/nao-liberado/services';

@Component({
    selector: 'sgt-campanha-pedido-liberar',
    templateUrl: './campanha-pedido-liberar.component.html',
    styleUrls: ['./campanha-pedido-liberar.component.less']
})
export class CampanhaPedidoLiberarComponent {
    @Input() idCampanha: number;
    @Input() filter: CampanhaFilter;

    @Output() afterLiberarPedido = new EventEmitter<void>();

    @ViewChild('form') form: NgForm;
    @ViewChild('pedidosNaoLiberadosView', {static: true}) pedidosNaoLiberadosView: CampanhaPedidoNaoLiberadoViewComponent;
    @ViewChild('justificativaTextArea') justificativaTextArea: ElementRef;

    req = new PedidoLiberarRequest(null);

    constructor(private formsUtilsService: FormsUtilsService,
                private messageService: MessageService,
                private pedidoNaoLiberadoHttpService: PedidoNaoLiberadoHttpService) { }

    /** Pesquisa os pedidos não liberados */
    searchPedidos() {
        this.pedidosNaoLiberadosView?.search();
    }

    /** Seta o foco na justificativa da liberação */
    setFocusJustificativa() {
        jQuery(this.justificativaTextArea?.nativeElement).trigger('focus');
    }

    /** Verifica se a liberação dos pedidos da campanha está válida */
    private isValid(): boolean {
        this.formsUtilsService.makeAllFieldsDirty(this.form);

        // Justificativa não informada
        if (!this.req.justificativaLiberado || this.req.justificativaLiberado.trim().length < 15) {
            this.messageService.warning('Informe uma justificativa contendo pelo menos 15 caracteres explicando o porquê você está liberando este(s) pedido(s)', 'Atenção', notCloseMessageOptions);
            this.setFocusJustificativa();
            return false;
        }
        // Form válido
        if (this.form.invalid) {
            this.messageService.warning('Informe corretamente todos os campos para liberar este(s) pedido(s)', 'Atenção', notCloseMessageOptions);
            return false;
        }

        return true;
    }

    /** Libera todos os pedidos não liberados da campanha */
    liberar(): Promise<void> {
        return new Promise<void>(async (resolve, reject) => {
            if (!this.isValid()) {
                reject();
                return;
            }

            // Obtendo todos os pedidos não liberados
            const pedidos = await this.pedidosNaoLiberadosView.getPedidos();
            pedidos?.forEach(pedido => this.req.ids.push(pedido.id));
            // Liberando os pedidos
            this.pedidoNaoLiberadoHttpService.liberar(this.req)
                .subscribe(
                    response => {
                        this.messageService.success('', 'Pedido(s) liberado(s) com sucesso');
                        this.searchPedidos();
                        resolve();
                    },
                    (error: ApiError) => {
                        this.messageService.error(error.message, error.cause, error);
                        reject();
                    }
                );
        });
    }
}
